import { ResidencyStatus } from "../ResidencyStatus";

export const ResidencyStatusLabels = {
  [ResidencyStatus.PermanentResident]: "Permanent Resident",
  [ResidencyStatus.CurrentlyInAustraliaOnVisa]:
    "Currently in Australia on a Visa",
} as const;
